import {AppState} from '../store';
import {format} from 'date-fns';

export const getNotificationsData = (state: AppState) =>
  state.notifications.data;

export const getNotificationList = (
  state: AppState,
): {id: number; message: string; timestamp: string; active: boolean}[] =>
  state.notifications.data.map(({id, message, timestamp, active}) => ({
    id,
    message,
    timestamp: format(new Date(timestamp), 'H:mm  d MMMM yyyy'),
    active,
  }));
